import { useEffect } from 'react';

/**
 * Sets document.title, meta description, canonical, and Open Graph tags from CMS page data.
 */
export function useSeoMeta(page) {
  useEffect(() => {
    if (!page) return;
    const title = page.seo_title || page.title || 'The Fashion Detective';
    document.title = title;

    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) { metaDesc = document.createElement('meta'); metaDesc.setAttribute('name', 'description'); document.head.appendChild(metaDesc); }
    metaDesc.setAttribute('content', page.seo_description || '');

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical); }
    canonical.setAttribute('href', window.location.origin + window.location.pathname);

    // Open Graph
    const ogTags = [
      { property: 'og:title', content: title },
      { property: 'og:description', content: page.seo_description || '' },
      { property: 'og:url', content: window.location.origin + window.location.pathname },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'The Fashion Detective' },
    ];
    ogTags.forEach(tag => {
      let el = document.querySelector(`meta[property="${tag.property}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute('property', tag.property); document.head.appendChild(el); }
      el.setAttribute('content', tag.content);
    });

    return () => { document.title = 'The Fashion Detective'; };
  }, [page]);
}
